import { commonErrorApiCodeMicroLab } from "./errors-api-code-micro-lab";
import { commonErrorApiCodeResourcesMicroLab } from "./errors-api-code-resources-micro-lab";

// Domain error-code dictionary, composed by the owning app transport.
// Assembled only from generated own namespaces, never from the monolithic catalog.
export const errorCodeDomain = {
  apiCodes: {
    ...commonErrorApiCodeMicroLab,
  },
  apiCodeResources: {
    ...commonErrorApiCodeResourcesMicroLab,
  },
  apiCodeReasons: {
  },
} as const;
